import React, { Component } from 'react';
import PT from 'prop-types';
import { Button, IconButton, Textbox, ResponsivenessGrid } from '../toolkit';
import TranslatorManager from 'ts-translate-js';
import tsRest from 'ts-rest-client';

const tr = TranslatorManager.boundTR;


export function OtherControls({ integ, subscriptionLink, facebookLink, twitterLink, homeUrl }) {
    return <div className="info-box-content">
        <ResponsivenessGrid breakpointsConfigs={{ mobile: 767, tablet: 1250, small: 1580, large: 50000 }} nbrColumnsByBreakpointConfigs={{ mobile: 1, tablet: 2, small: 2, large: 2 }}
                            items={[
                                <Newsletter key="newsletter" subscriptionLink={subscriptionLink}
                                />,
                                <div key="others">
                                    <GiftCertificate integ={integ} homeUrl={homeUrl} />
                                    <SocialMediasBox facebookLink={facebookLink} twitterLink={twitterLink}/>
                                </div>
                            ]}
        />
    </div>;
}
OtherControls.propTypes = {
    integ: PT.string,
    subscriptionLink: PT.string,
    facebookLink: PT.string,
    twitterLink: PT.string,
    homeUrl: PT.string
};

class Newsletter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: null,
            userEmail: null
        };
    }

    onInputChange(name, value) {
        this.setState({ [name]: value });
    }

    render() {
        return (
            <div className="row-content-with-padding info-box-item newsletter"
                 style={{backgroundImage: `url("/static/tsapp/latest/img/img-fond-courriel.png")`}}>
                <h3>{tr("Restez informés")}</h3>
                <p dangerouslySetInnerHTML={{
                    __html: tr(`Recevez toutes les nouvelles sur les spectacles à venir, les dates de mise en vente de billets, nos concours et plus encore...`)}
                } />
                <form action={this.props.subscriptionLink} method="post" id="newletter-form">
                    <Textbox
                        id="cm-name"
                        name="cm-name"
                        placeholder={tr("Nom complet")}
                        value={this.state.username || ""}
                        onChange={this.onInputChange.bind(this, "username")}
                    />
                    <br />
                    <Textbox
                        id="cm-pihlkl-pihlkl"
                        name="cm-pihlkl-pihlkl"
                        placeholder={tr("Adresse courriel")}
                        value={this.state.userEmail || ""}
                        onChange={this.onInputChange.bind(this, "userEmail")}
                    />
                    <br />
                    <Button 
                        id="subscribe-newsletter-button" 
                        isLarge={true} 
                        type="submit"
                    >
                        <i className="rese-button-icon material-icons mdc-button__icon" aria-hidden="true">email</i>
                        <span>{tr("Je m'abonne")}</span>
                    </Button>
                </form>
            </div>
        );
    }
}
Newsletter.propTypes = {
    subscriptionLink: PT.string
};

class GiftCertificate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            purchaseUrl: ""
        };
    }

    componentDidMount() {
        this.getGiftCertificateUrl();
    }

    async getGiftCertificateUrl() {
        try {
            const result = await tsRest.get(`/integration/${this.props.integ}/giftcertificateurl?homeUrl=${this.props.homeUrl}`);
            this.setState({purchaseUrl: result});
        }
        catch(err) {
            tsRest.handleError(err);
        }
    }

    onBuyGiftCertificate() {
        window.location.href = this.state.purchaseUrl;
    }

    render() {
        return (
            <div className="row-content-with-padding info-box-item gift-certificate" style={{ backgroundImage: "url('../static/tsapp/latest/img/img-fond-carte-cadeau.png')" }}>
                <h3>{tr("En panne d'idée cadeau?")}</h3>
                <p dangerouslySetInnerHTML={{__html: tr("Optez pour un certificat-cadeau Reservatech.net. Choisissez le montant que vous désirez!")}} />
                <div className="spacer-row"></div>
                <div>
                    <Button id="btn-gift-certificate"
                            isLarge={true}
                            onButtonClicked={this.onBuyGiftCertificate.bind(this)}>
                        <i className="rese-button-icon material-icons mdc-button__icon" aria-hidden="true">local_activity</i>
                        <span>{tr("Acheter")}</span>
                    </Button>
                </div>
            </div>
        );
    }
}
GiftCertificate.propTypes = {
    integ: PT.string,
    homeUrl: PT.string
};

export function SocialMediasBox({ facebookLink, twitterLink }) {
    
    return <div className="info-box-item social-media">
        <div className="info-box-center">
            <div className="info-box-horizontal-align">
                <h3>{tr("Suivez-nous")}</h3>
                <SocialMedias facebookLink={facebookLink} twitterLink={twitterLink}></SocialMedias>
            </div>
        </div>
    </div>;
}
SocialMediasBox.propTypes = {
    facebookLink: PT.string,
    twitterLink: PT.string
};


export function SocialMedias({ facebookLink, twitterLink, instagramLink }) {
    /* eslint-disable security/detect-non-literal-fs-filename */
    return <>
        {facebookLink && <IconButton classNames={["social-media-icon"]} icon={{ className: "fab fa-facebook-f facebook" }} onClick={() => { window.open(facebookLink, '_blank'); }} />}
        {twitterLink && <IconButton classNames={["social-media-icon"]} icon={{ className: "fab fa-twitter twitter" }} onClick={() => { window.open(twitterLink, '_blank'); }} />}
        {instagramLink && <IconButton classNames={["social-media-icon"]} icon={{ className: "fab fa-instagram instagram" }} onClick={() => { window.open(instagramLink, '_blank'); }} />}
    </>;
}
SocialMedias.propTypes = {
    facebookLink: PT.string,
    twitterLink: PT.string,
    instagramLink: PT.string
};

export function NoProductSection({ message }) {
    return (
        <div className="row-content">
            <div className="no-result">
                {message}
            </div>
        </div>
    );
}
NoProductSection.propTypes = {
    message: PT.string.isRequired
};
